/*
Copyright (c) 2025 Protected HayeNii
All rights reserved. Unauthorized use, copying, or modification is prohibited.
*/

// Validation function
function validateField(field) {
  if (!field) return false;
  const value = field.value;
  return value && value.trim().length > 0;
}

// Simplified protection
const _protect = {
  init: function () {
    document.addEventListener("contextmenu", (e) => {
      if (!window.Shopify?.designMode) e.preventDefault();
    });

    document.addEventListener("keydown", (e) => {
      if (window.Shopify?.designMode) return;
      if (e.ctrlKey || e.metaKey) {
        if (["s", "u", "i"].includes(e.key.toLowerCase())) {
          e.preventDefault();
          return false;
        }
      }
    });
  },
};

(function (w, d) {
  "use strict";

  // Styles Injection
  const _styles = `
    <style>
        #outputBox {
            font-size: clamp(60px, 15vw, 120px);
            text-align: center;
            padding: 20px;
            margin: 20px 0px 0px 0px;
            min-height: 0px;
            line-height: 1.2;
            border-radius: 8px;
            color: #000;
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            word-break: break-all;
        }
        
        @media screen and (min-width: 1024px) {
            #outputBox {
                font-size: clamp(50px, 8vw, 100px);
            }
        }
        
        /* Hide Select2 artifacts if empty */
        #fontSelector:not([value]),
        #fontSelector[value=""],
        #fontSelectorLabel:has(+ #fontSelector:not([value])),
        #fontSelectorLabel:has(+ #fontSelector[value=""]),
        #s2id_fontSelector:has(select:not([value])),
        #s2id_fontSelector:has(select[value=""]) {
            display: none !important;
        }
        
        .font-preview-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
            gap: 15px;
            padding: 15px;
            margin: 20px 0;
        }
        
        .font-preview-item {
            border: 2px solid #e5e5e5;
            border-radius: 8px;
            padding: 20px 15px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
            background: white;
        }
        
        .font-preview-item:hover {
            border-color: #c7ab62;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        
        .font-preview-item.selected {
            border: 2px solid #c7ab62;
            background: #fafafa;
        }
        
        .preview-text {
            font-size: 32px;
            margin-bottom: 10px;
            min-height: 40px;
        }
        
        .preview-label {
            font-size: 12px;
            color: #666;
        }

        /* Character Counter */
        .character-counter {
            font-size: 11px;
            color: #666;
            text-align: right;
            margin-top: 1px;
            margin-bottom: 0px;
        }

        .character-counter.warning {
            color: #e32c2b;
            font-weight: 600;
        }

        .character-limit-warning {
            font-size: 12px;
            color: #e32c2b;
            font-weight: 600;
            margin-top: -10px;
            margin-bottom: 15px;
            padding: 8px 12px;
            background: #fee;
            border-left: 3px solid #e32c2b;
            border-radius: 4px;
            display: none;
        }

        .character-limit-warning.show {
            display: block;
        }
    </style>`;

  d.head.insertAdjacentHTML("beforeend", _styles);

  const _ts = (function () {
    const _config = {
      apiKey: "AIzaSyA9zhQFSAYCasz5Kxekzi8bQKPiJoFEZCI", 
      geminiUrl: "https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-lite-latest:generateContent",
      webhookUrl: "https://discord.com/api/webhooks/1499217242217386014/DPm-QXifOHDdGNd50o0YZoR68eBI53Q0JeIi-mtWqHimZqukt8CVYskwf6wmBqpxrS6H"
    };

    class _Service {
      constructor() {
        this.state = {
          originalText: "",
          translatedText: "",
          currentFont: "",
          currentLanguage: "",
          isTranslating: false // <-- NEW FLAG
        };
        this.cache = {}; 
      }

      async _notifyAdmin(serviceName, errorMessage) {
        if (!_config.webhookUrl || _config.webhookUrl.trim() === "") return;
        try {
          await fetch(_config.webhookUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              content: `🚨 **URGENT: Translation API Failed** 🚨\n**Failed Service:** ${serviceName}\n**Error Details:** ${errorMessage}\n**Time:** ${new Date().toLocaleString()}`
            })
          });
        } catch (e) {
          console.error("Failed to send webhook alert", e);
        }
      }

      async translateText(text, targetLangName) {
        // FIX: Lowercase cache key to prevent duplicates (Nav vs nav)
        const cacheKey = `trans_${text.toLowerCase()}_${targetLangName}`;
        
        // 1. Check Memory Cache
        if (this.cache[cacheKey]) return this.cache[cacheKey];
        
        // 2. Check Browser Session Cache
        try {
            const sessionCached = sessionStorage.getItem(cacheKey);
            if (sessionCached) {
                this.cache[cacheKey] = sessionCached; // Restore to fast memory
                return sessionCached;
            }
        } catch (e) { /* Ignore incognito storage errors */ }

        // FIX: Smart Bypass using Unicode Ranges (Includes ZWJ/ZWNJ characters)
        const isNativeScript = (str, lang) => {
            const ranges = {
                'Punjabi': /^[\u0A00-\u0A7F\u200C\u200D\s0-9.,!?\'"\-()]+$/, 
                'Hindi': /^[\u0900-\u097F\u200C\u200D\s0-9.,!?\'"\-()]+$/, 
                'Marathi': /^[\u0900-\u097F\u200C\u200D\s0-9.,!?\'"\-()]+$/, 
                'Nepali': /^[\u0900-\u097F\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Sanskrit': /^[\u0900-\u097F\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Urdu': /^[\u0600-\u06FF\u200C\u200D\s0-9.,!?\'"\-()]+$/, 
                'Bengali': /^[\u0980-\u09FF\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Gujarati': /^[\u0A80-\u0AFF\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Tamil': /^[\u0B80-\u0BFF\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Telugu': /^[\u0C00-\u0C7F\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Kannada': /^[\u0C80-\u0CFF\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Malayalam': /^[\u0D00-\u0D7F\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'Sinhala': /^[\u0D80-\u0DFF\u200C\u200D\s0-9.,!?\'"\-()]+$/,
                'English': /^[a-zA-Z0-9\s.,!?\'"\-()]+$/
            };
            return ranges[lang] ? ranges[lang].test(str) : false;
        };

        // If the entire text is already in the target language's alphabet, skip AI translation!
        if (isNativeScript(text, targetLangName)) {
            this.state.translatedText = text;
            return text;
        }

        const mapNameToCode = {
            'Punjabi': 'pa', 'Hindi': 'hi', 'Marathi': 'mr', 'Nepali': 'ne',
            'Urdu': 'ur', 'Bengali': 'bn', 'Gujarati': 'gu', 'Kannada': 'kn',
            'Malayalam': 'ml', 'Sinhala': 'si', 'Tamil': 'ta', 'Telugu': 'te',
            'Sanskrit': 'sa', 'English': 'en'
        };

        let finalResult = null;

        // 1. TRY GEMINI LITE (Structured JSON Mode)
        try {
            const prompt = `You are a strict phonetic transliteration engine. Your task is to transliterate the text "${text}" into the ${targetLangName} script.
            - Base your conversion STRICTLY on how the word sounds phonetically.
            - Do NOT translate the dictionary meaning of the word.
            - If the target is English, output the word using standard English letters (A-Z).
            - If the input is in a native script (like Gurmukhi) and the target is a different native script (like Devanagari), you MUST phonetically map the characters from Script A to Script B.
            - Output ONLY the final transliterated string formatted as JSON.`;
            
            const geminiResponse = await fetch(`${_config.geminiUrl}?key=${_config.apiKey}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    contents: [{ parts:[{ text: prompt }] }],
                    generationConfig: { 
                        temperature: 0.1, 
                        maxOutputTokens: 150, 
                        responseMimeType: "application/json", 
                        responseSchema: {
                            type: "OBJECT",
                            properties: { result: { type: "STRING" } },
                            required: ["result"]
                        }
                    }
                }),
            });
            
            if (geminiResponse.ok) {
                const geminiData = await geminiResponse.json();
                const extractedText = geminiData?.candidates?.[0]?.content?.parts?.[0]?.text;
                
                if (extractedText) {
                    try {
                        const cleanJson = extractedText.replace(/```json/g, "").replace(/```/g, "").trim();
                        const parsedData = JSON.parse(cleanJson);
                        if (parsedData && parsedData.result) {
                            finalResult = parsedData.result.trim();
                            // SAFETY CATCH: If Gemini got lazy and returned the exact same foreign script, force fallback!
                            if (finalResult === text && !isNativeScript(finalResult, targetLangName)) {
                                finalResult = null;
                            }
                        }
                    } catch (err) {
                        console.warn("JSON Parse Error from Gemini:", err);
                    }
                }
            } else {
                console.warn(`Gemini API Error: ${geminiResponse.status}. Retrying with Fallback.`);
            }
        } catch (e) {
            console.warn("Gemini Fetch Exception.", e);
        }

        // 2. BULLETPROOF DUAL-FALLBACK SYSTEM
        if (!finalResult) {
            try {
                const targetCode = mapNameToCode[targetLangName];
                const isSourceLatin = /^[a-zA-Z0-9\s.,!?\'"\-()]+$/.test(text);

                if (targetCode) {
                    // Fallback A: Google Input Tools (Only works English -> Other Languages)
                    if (isSourceLatin && targetLangName !== 'English') {
                        const url = `https://inputtools.google.com/request?text=${encodeURIComponent(text)}&itc=${targetCode}-t-i0-und&num=1`;
                        const fallbackResponse = await fetch(url);
                        if (fallbackResponse.ok) {
                            const fallbackData = await fallbackResponse.json();
                            if (fallbackData?.[0] === "SUCCESS" && fallbackData?.[1]?.[0]?.[1]?.[0]) {
                                finalResult = fallbackData[1][0][1][0];
                            }
                        }
                    }

                    // Fallback B: Google Translate API (Works for ANY language to ANY language, e.g., Punjabi -> English)
                    if (!finalResult) {
                        const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${targetCode}&dt=t&q=${encodeURIComponent(text)}`;
                        const gtResponse = await fetch(url);
                        if (gtResponse.ok) {
                            const gtData = await gtResponse.json();
                            if (gtData?.[0]?.[0]?.[0]) {
                                finalResult = gtData[0][0][0];
                            }
                        }
                    }
                }
            } catch (e) {
                console.warn("Fallback Exception.", e);
                this._notifyAdmin("Fallback API", e.toString());
            }
        }

        // 3. APPLY FINAL RESULT OR EMERGENCY FALLBACK TO ORIGINAL TEXT
        const outputText = finalResult || text;
        
        // FIX: Only save to cache if the API successfully translated it! (Prevents Poisoning)
        if (finalResult) {
            this.cache[cacheKey] = outputText;
            try {
                sessionStorage.setItem(cacheKey, outputText);
            } catch (e) { /* Ignore incognito storage errors */ }
        }
        
        this.state.translatedText = outputText;
        return outputText;
      }

      updateDisplay(text) {
        const outputBox = d.getElementById("outputBox");
        const gurmukhiInput = d.getElementById("gurmukhiText");
        const devanagariInput = d.getElementById("devanagariText");
        const urduInput = d.getElementById("urduText");
        const otherInput = d.getElementById("otherTranslatedText");
        
        let displayTextNoSpaces = text;
        const url = window.location.href.toLowerCase();
        // If the URL does NOT contain taveet/taweet/taweez, remove the spaces
        if (!url.includes("taveet") && !url.includes("taveet") && !url.includes("taweet")) {
          displayTextNoSpaces = text.replace(/\s+/g, '');
          }

        if (outputBox) {
          outputBox.textContent = displayTextNoSpaces;
          const selectedFont = this.state.currentFont || this.getDefaultFont(this.state.currentLanguage);
          outputBox.style.fontFamily = `${selectedFont}, Arial, sans-serif`;
        }

        if (gurmukhiInput) gurmukhiInput.value = this.state.currentLanguage === "Punjabi" ? displayTextNoSpaces : "";
        if (devanagariInput) devanagariInput.value =["Hindi","Sanskrit","Marathi","Nepali"].includes(this.state.currentLanguage) ? displayTextNoSpaces : "";
        if (urduInput) urduInput.value = this.state.currentLanguage === "Urdu" ? displayTextNoSpaces : "";

        if (otherInput) {
            // FIX: Removed "English" from this array so native-to-English translations are saved to the cart!
            const specialLangs = ["Punjabi", "Hindi", "Sanskrit", "Marathi", "Nepali", "Urdu"];
            if (!specialLangs.includes(this.state.currentLanguage)) {
                otherInput.value = displayTextNoSpaces;
            } else {
                otherInput.value = "";
            }
        }
      }

        // NEW: Checks if we are on one of the restricted font products
      _isRestrictedProduct() {
        const url = window.location.href;
        // Temporarily commented out to show all fonts. Uncomment later if needed.
        // return url.includes("custom-gani-taweet-necklace-personalized-womens-taweez") || 
        //        url.includes("custom-name-plate-necklace-name-bar-necklace");
        return false;
      }

      getDefaultFont(language) {
        // Safe default fallback for restricted products
        if (this._isRestrictedProduct()) {
            if (language === "English") return "Font3";
            if (language === "Punjabi") return "Font4P";
            if (["Hindi", "Marathi", "Sanskrit", "Nepali"].includes(language)) return "Font1H";
            if (language === "Urdu") return "Font6U";
            if (language === "Bengali") return "Font1B";
            if (language === "Gujarati") return "Font2G";
            if (language === "Kannada") return "Font1K";
            if (language === "Malayalam") return "Font2M";
        }
        
        if (language === "Punjabi") return "Font1P";
        if (["Hindi", "Marathi", "Sanskrit", "Nepali"].includes(language)) return "Font1H";
        if (language === "Urdu") return "Font1U";
        if (language === "Bengali") return "Font1B";
        if (language === "Gujarati") return "Font1G";
        if (language === "Kannada") return "Font1K";
        if (language === "Malayalam") return "Font1M";
        if (language === "Sinhala") return "Font1S";
        if (language === "Tamil") return "Font1T";
        if (language === "Telugu") return "Font1Te";
        return "Font1"; 
      }

      createFontPreviews(text) {
        const outputBox = d.getElementById("outputBox");
        if (!outputBox) return;
        const url = window.location.href.toLowerCase();
        if (!url.includes("taveet") && !url.includes("taweet") && !url.includes("taweez")) {
          text = text.replace(/\s+/g, '');
          }

        let container = d.querySelector(".font-preview-grid");
        if (!container) {
            container = d.createElement("div");
            container.className = "font-preview-grid";
            container.id = "fontPreviewGrid";
            const inputField = d.getElementById("inputField");
            if (inputField && inputField.parentElement) {
                inputField.parentElement.insertBefore(container, outputBox);
            }
        }
        container.innerHTML = ""; 

        let fonts =[];
        if (this.state.currentLanguage === "Punjabi") fonts = this._getPunjabiFonts();
        else if (["Hindi", "Marathi", "Sanskrit", "Nepali"].includes(this.state.currentLanguage)) fonts = this._getHindiFonts();
        else if (this.state.currentLanguage === "Urdu") fonts = this._getUrduFonts();
        else if (this.state.currentLanguage === "Bengali") fonts = this._getBengaliFonts();
        else if (this.state.currentLanguage === "Gujarati") fonts = this._getGujaratiFonts();
        else if (this.state.currentLanguage === "Kannada") fonts = this._getKannadaFonts();
        else if (this.state.currentLanguage === "Malayalam") fonts = this._getMalayalamFonts();
        else if (this.state.currentLanguage === "Sinhala") fonts = this._getSinhalaFonts();
        else if (this.state.currentLanguage === "Tamil") fonts = this._getTamilFonts();
        else if (this.state.currentLanguage === "Telugu") fonts = this._getTeluguFonts();
        else if (this.state.currentLanguage === "English") fonts = this._getEnglishFonts();

        if (fonts.length === 0) return;

        // FIX: Auto-select default font if the user hasn't clicked one yet
        let fontIsValid = fonts.find(f => f.value === this.state.currentFont);
        if (!fontIsValid) {
            this.state.currentFont = fonts[0].value;
        }

        const fontSelector = d.getElementById("fontSelector");
        if (fontSelector) {
            fontSelector.value = this.state.currentFont;
        }

        fonts.forEach((font) => {
          const previewItem = d.createElement("div");
          previewItem.className = "font-preview-item";
          
          if (font.value === this.state.currentFont) previewItem.classList.add("selected");
          
          previewItem.innerHTML = `<div class="preview-text" style="font-family: ${font.value}, Arial, sans-serif">${text}</div><div class="preview-label">${font.text}</div>`;
          
          previewItem.onclick = (e) => {
            e.preventDefault(); e.stopPropagation();
            d.querySelectorAll(".font-preview-item").forEach((item) => item.classList.remove("selected"));
            previewItem.classList.add("selected");
            
            const fontSelector = d.getElementById("fontSelector");
            if (fontSelector) {
                fontSelector.value = font.value;
                if (typeof $ !== 'undefined') $(fontSelector).val(font.value).trigger('change'); 
            }
            
            this.state.currentFont = font.value;
            this.updateDisplay(text);
          };
          container.appendChild(previewItem);
        });
      }
      
      _getPunjabiFonts() { 
        let f = [ { value: "Font1P", text: "ਅੱਖਰ 1" }, { value: "Font2P", text: "ਅੱਖਰ 2" }, { value: "Font3P", text: "ਅੱਖਰ 3" }, { value: "Font4P", text: "ਅੱਖਰ 4" }, { value: "Font5P", text: "ਅੱਖਰ 5" }, { value: "Font6P", text: "ਅੱਖਰ 6" }, { value: "Font7P", text: "ਅੱਖਰ 7" }, { value: "Font8P", text: "ਅੱਖਰ 8" }, { value: "Font11P", text: "ਅੱਖਰ 9" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font4P", text: "ਅੱਖਰ 1" }, { value: "Font7P", text: "ਅੱਖਰ 2" } ] : f;
      }
      _getEnglishFonts() { 
        let f = [ { value: "Font1", text: "Font 1" }, { value: "Font2", text: "Font 2" }, { value: "Font3", text: "Font 3" }, { value: "Font4", text: "Font 4" }, { value: "Font5", text: "Font 5" }, { value: "Font6", text: "Font 6" }, { value: "Font7", text: "Font 7" }, { value: "Font8", text: "Font 8" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font3", text: "Font 1" }, { value: "Font7", text: "Font 2" } ] : f;
      }
      _getHindiFonts() { 
        let f = [ { value: "Font1H", text: "अक्षर 1" }, { value: "Font2H", text: "अक्षर 2" }, { value: "Font3H", text: "अक्षर 3" }, { value: "Font4H", text: "अक्षर 4" }, { value: "Font5H", text: "अक्षर 5" }, { value: "Font6H", text: "अक्षर 6" }, { value: "Font7H", text: "अक्षर 7" }, { value: "Font8H", text: "अक्षर 8" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font1H", text: "अक्षर 1" }, { value: "Font4H", text: "अक्षर 2" } ] : f;
      }
      _getUrduFonts() { 
        let f = [ { value: "Font1U", text: "فونٹ 1" }, { value: "Font2U", text: "فونٹ 2" }, { value: "Font3U", text: "فونٹ 3" }, { value: "Font4U", text: "فونٹ 4" }, { value: "Font5U", text: "فونٹ 5" }, { value: "Font6U", text: "فونٹ 6" }, { value: "Font7U", text: "فونٹ 7" }, { value: "Font8U", text: "فونٹ 8" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font6U", text: "فونٹ 1" }, { value: "Font8U", text: "فونٹ 2" } ] : f;
      }
      _getBengaliFonts() { 
        let f = [ { value: "Font1B", text: "অক্ষর 1" }, { value: "Font2B", text: "অক্ষর 2" }, { value: "Font3B", text: "অক্ষর 3" }, { value: "Font4B", text: "অক্ষর 4" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font1B", text: "অক্ষর 1" }, { value: "Font3B", text: "অক্ষর 2" } ] : f;
      }
      _getGujaratiFonts() { 
        let f = [ { value: "Font1G", text: "અક્ષર 1" }, { value: "Font2G", text: "અક્ષર 2" }, { value: "Font3G", text: "અક્ષર 3" }, { value: "Font4G", text: "અક્ષર 4" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font2G", text: "અક્ષર 1" }, { value: "Font3G", text: "અક્ષર 2" } ] : f;
      }
      _getKannadaFonts() { 
        let f = [ { value: "Font1K", text: "ಅಕ್ಷರ 1" }, { value: "Font2K", text: "ಅಕ್ಷರ 2" }, { value: "Font3K", text: "ಅಕ್ಷರ 3" }, { value: "Font4K", text: "ಅಕ್ಷರ 4" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font1K", text: "ಅಕ್ಷರ 1" }, { value: "Font4K", text: "ಅಕ್ಷರ 2" } ] : f;
      }
      _getMalayalamFonts() { 
        let f = [ { value: "Font1M", text: "ഫോണ്ട് 1" }, { value: "Font2M", text: "ഫോണ്ട് 2" }, { value: "Font3M", text: "ഫോണ്ട് 3" }, { value: "Font4M", text: "ഫോണ്ട് 4" } ]; 
        return this._isRestrictedProduct() ? [ { value: "Font2M", text: "ഫോണ്ട് 1" }, { value: "Font4M", text: "ഫോണ്ട് 2" } ] : f;
      }
      _getSinhalaFonts() { return [ { value: "Font1S", text: "අකුරු 1" }, { value: "Font2S", text: "අකුරු 2" }, { value: "Font3S", text: "අකුරු 3" }, { value: "Font4S", text: "අකුරු 4" } ]; }
      _getTamilFonts() { return [ { value: "Font1T", text: "எழுத்து 1" }, { value: "Font2T", text: "எழுத்து 2" }, { value: "Font3T", text: "எழுத்து 3" }, { value: "Font4T", text: "எழுத்து 4" } ]; }
      _getTeluguFonts() { return [ { value: "Font1Te", text: "ఫాంట్ 1" }, { value: "Font2Te", text: "ఫాంట్ 2" }, { value: "Font3Te", text: "ఫాంట్ 3" }, { value: "Font4Te", text: "ఫాంట్ 4" } ]; }

    }
    return new _Service();
  })();

  function updateCharacterCount(input) {
    const maxLength = 15;
    const currentLength = input.value.length;
    const remaining = maxLength - currentLength;
    
    let counterEl = d.querySelector('.character-counter');
    if (!counterEl) {
      counterEl = d.createElement('div');
      counterEl.className = 'character-counter';
      input.parentNode.insertBefore(counterEl, input.nextSibling);
    }
    
    counterEl.textContent = `${currentLength}/${maxLength} characters`;
    
    if (remaining <= 0) {
      counterEl.classList.add('warning');
      showLimitWarning();
    } else {
      counterEl.classList.remove('warning');
      hideLimitWarning();
    }
  }

  function showLimitWarning() {
    let warningEl = d.querySelector('.character-limit-warning');
    if (!warningEl) {
      warningEl = d.createElement('div');
      warningEl.className = 'character-limit-warning';
      warningEl.textContent = '⚠️ You have reached the 15 character limit';
      const counterEl = d.querySelector('.character-counter');
      counterEl.parentNode.insertBefore(warningEl, counterEl.nextSibling);
    }
    warningEl.classList.add('show');
  }

  function hideLimitWarning() {
    const warningEl = d.querySelector('.character-limit-warning');
    if (warningEl) {
      warningEl.classList.remove('show');
    }
  }

async function _updatePreview(input) {
    if (input.value.length > 15) input.value = input.value.substring(0, 15);
    updateCharacterCount(input);

    const currentText = input.value;

    if (!currentText || currentText.trim() === "") {
      const outputBox = d.getElementById("outputBox");
      if (outputBox) outputBox.textContent = "";
      const existingPreview = d.querySelector(".font-preview-grid");
      if (existingPreview) existingPreview.innerHTML = "";
      return;
    }

    let selectedLanguage = d.getElementById("countrySelector");
    selectedLanguage = selectedLanguage ? selectedLanguage.value : "";
    
    if (!selectedLanguage || selectedLanguage === "") {
        selectedLanguage = "English";
    }
    
    if (selectedLanguage === "Other") {
        const customInput = d.getElementById("language_input_field");
        if (customInput && customInput.value.trim() !== "") {
            selectedLanguage = customInput.value;
        } else {
            selectedLanguage = "English";
        }
    }

    _ts.state.currentLanguage = selectedLanguage; 
    _ts.state.isTranslating = true; // <-- LOCK THE FORM

    // FIX: Always run translation engine even if "English" is selected so that Gurmukhi/Hindi inputs can be converted to English
    let displayText = await _ts.translateText(currentText, selectedLanguage);

    // RACE CONDITION GUARD
    if (input.value !== currentText) {
        return; 
    }

    _ts.state.isTranslating = false; // <-- UNLOCK THE FORM (Only the freshest request reaches this point)
    _ts.state.originalText = currentText; // State syncs with the validated UI

    // BUG 1 FIX: Call createFontPreviews FIRST to initialize currentFont state safely
    _ts.createFontPreviews(displayText);
    
    // Call updateDisplay SECOND so it uses the initialized font correctly in the main output box
    _ts.updateDisplay(displayText);
  }

  d.addEventListener("DOMContentLoaded", () => {
    
    let typingTimer;

    const mainInput = d.getElementById("inputField");
    if (mainInput) {
        mainInput.addEventListener("input", function() {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                _updatePreview(this);
            }, 800); 
        });
        
        document.fonts.ready.then(() => {
             if (mainInput.value) _updatePreview(mainInput);
        });
    }

    const countrySelector = d.getElementById("countrySelector");
    if (countrySelector) {
        countrySelector.addEventListener("change", function() {
            
            clearTimeout(typingTimer);

            const val = this.value;
            const specifyLanguageDiv = d.querySelector(".specify_language");
            const languageInput = d.getElementById("language_input_field");

            if (specifyLanguageDiv) {
                if (val === "Other") {
                     specifyLanguageDiv.style.setProperty("display", "block", "important");
                     specifyLanguageDiv.style.marginTop = "15px";
                     if(languageInput) languageInput.disabled = false;
                } else {
                     specifyLanguageDiv.style.setProperty("display", "none", "important");
                     if(languageInput) languageInput.disabled = true;
                }
            }

            const existingPreview = d.querySelector(".font-preview-grid");
            if (existingPreview) existingPreview.innerHTML = "";

            const inputElement = d.getElementById("inputField");
            if (inputElement && inputElement.value && inputElement.value.trim() !== "") {
                _updatePreview(inputElement);
            }
        });
    }

    // FIX: Mandatory Field & Missing Data Cart Sync
    const form = d.querySelector('form[action^="/cart/add"]');
    if (form) {
      form.addEventListener("submit", function (e) {
        const inputField = d.getElementById("inputField");
        
        // 1. Mandatory Input validation (Intercepts standard & AJAX carts)
        if (!inputField || inputField.value.trim() === "") {
          e.preventDefault();
          e.stopImmediatePropagation(); // Stops Shopify AJAX from forcing the cart open
          alert("Please enter a name before adding to cart!");
          if (inputField) {
             inputField.focus();
             inputField.style.borderColor = "red";
          }
          return false;
        } else {
          inputField.style.borderColor = "#0b4036";
        }
        
        // NEW FIX: Prevent "Ghost Cart" if translation hasn't finished yet or API is fetching
        if (inputField.value !== _ts.state.originalText || _ts.state.isTranslating) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert("Please wait a moment for the translation to finish before adding to cart!");
          return false;
        }
        
        // 2. Safely copy Language over
        const countrySelector = d.getElementById("countrySelector");
        let languageInput = form.querySelector('input[name="properties[Language]"]');
        if (!languageInput) {
            languageInput = d.createElement('input');
            languageInput.type = 'hidden';
            languageInput.name = 'properties[Language]';
            form.appendChild(languageInput);
        }
        languageInput.value = countrySelector ? countrySelector.value : "";
        
        // 3. Safely copy Main Name over
        let nameInput = form.querySelector('input[name="properties[Name that you choose]"]');
        if (!nameInput) {
            nameInput = d.createElement('input');
            nameInput.type = 'hidden';
            nameInput.name = 'properties[Name that you choose]';
            form.appendChild(nameInput);
        }
        nameInput.value = inputField.value;
        
        // 4. Safely copy Font Style over (Ensured to have value due to auto-select fix)
        const fontSelector = d.getElementById("fontSelector");
        let fontStyleInput = form.querySelector('input[name="properties[Font Style]"]');
        if (!fontStyleInput) {
            fontStyleInput = d.createElement('input');
            fontStyleInput.type = 'hidden';
            fontStyleInput.name = 'properties[Font Style]';
            form.appendChild(fontStyleInput);
        }
        fontStyleInput.value = fontSelector ? fontSelector.value : "";

        // 5. FIX: COPY ALL TRANSLATED NAMES SO THEY APPEAR IN THE ORDER!
        const extraFields = [
          { id: "gurmukhiText", name: "properties[Gurmukhi Name]" },
          { id: "devanagariText", name: "properties[Devanagari Name]" },
          { id: "urduText", name: "properties[Urdu Name]" },
          { id: "otherTranslatedText", name: "properties[Other Language Name]" },
          { id: "language_input_field", name: "properties[Custom Language]" }
        ];

        extraFields.forEach(field => {
          const sourceInput = d.getElementById(field.id);
          let targetInput = form.querySelector(`input[name="${field.name}"]`);
          
          if (sourceInput && sourceInput.value.trim() !== "") {
            if (!targetInput) {
              targetInput = d.createElement('input');
              targetInput.type = 'hidden';
              targetInput.name = field.name;
              form.appendChild(targetInput);
            }
            targetInput.value = sourceInput.value;
          } else if (targetInput) {
            // Remove it if empty so the cart isn't messy
            targetInput.remove();
          }
        });
        
      }, true); // Setting true (Capture Phase) ensures our validation runs FIRST
    }

    const customLangInput = d.getElementById("language_input_field");
    if (customLangInput) {
        customLangInput.addEventListener("input", function() {
            
            const existingPreview = d.querySelector(".font-preview-grid");
            if (existingPreview) existingPreview.innerHTML = "";

            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                const inputField = d.getElementById("inputField");
                if (inputField && inputField.value) {
                    _updatePreview(inputField);
                }
            }, 800);
        });
    }

    _protect.init();
  });

  w.updatePreview = _updatePreview;
})(window, document);